(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-product-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  function getSection(el) { return el.closest('.cpg-page'); }

  function applyFilters(sectionEl) {
    var grid = sectionEl.querySelector('.cpg-grid');
    var noRes = sectionEl.parentElement.querySelector('[id^="cpg-no-results"]');
    if (!grid) return;

    var showIn    = sectionEl.querySelector('[data-avail="in"]')?.checked ?? true;
    var showOut   = sectionEl.querySelector('[data-avail="out"]')?.checked ?? true;
    var showSale  = sectionEl.querySelector('.cpg-sale-filter')?.checked ?? true;
    var showNorm  = sectionEl.querySelector('.cpg-nonsale-filter')?.checked ?? true;

    var minInput  = sectionEl.parentElement.querySelector('.cpg-price-input:first-of-type');
    var maxInput  = sectionEl.parentElement.querySelector('.cpg-price-input:last-of-type');
    var minVal    = minInput && minInput.value !== '' ? parseFloat(minInput.value) * 100 : null;
    var maxVal    = maxInput && maxInput.value !== '' ? parseFloat(maxInput.value) * 100 : null;

    var cards = grid.querySelectorAll('.cpg-card');
    var visible = 0;

    cards.forEach(function (card) {
      var avail  = card.getAttribute('data-available') === 'true';
      var sale   = card.getAttribute('data-sale') === 'true';
      var price  = parseFloat(card.getAttribute('data-price') || '0');

      var show = true;
      if (avail  && !showIn)   show = false;
      if (!avail && !showOut)  show = false;
      if (sale   && !showSale) show = false;
      if (!sale  && !showNorm) show = false;
      if (minVal !== null && price < minVal) show = false;
      if (maxVal !== null && price > maxVal) show = false;

      card.style.display = show ? '' : 'none';
      if (show) visible++;
    });

    if (noRes) noRes.style.display = visible === 0 ? 'block' : 'none';
    if (grid)  grid.style.display  = visible === 0 ? 'none'  : '';
  }

  document.addEventListener('change', function (e) {
    var sec = getSection(e.target);
    if (sec) applyFilters(sec);
  });

  document.addEventListener('click', function (e) {
    var applyBtn = e.target.closest('.cpg-price-apply');
    if (applyBtn) {
      var sec = getSection(applyBtn) || applyBtn.closest('.cpg-wrap')?.querySelector('.cpg-page');
      if (sec) applyFilters(sec);
    }

    var resetBtn = e.target.closest('.cpg-reset-btn');
    if (resetBtn) {
      var wrap = document.querySelector('.cpg-wrap');
      var sec  = wrap && wrap.querySelector('.cpg-page');
      if (sec) {
        sec.querySelectorAll('input[type=checkbox]').forEach(function (cb) { cb.checked = true; });
        sec.querySelectorAll('.cpg-price-input').forEach(function (inp) { inp.value = ''; });
        applyFilters(sec);
      }
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
